
























import Vue from 'vue';
import customerVuex from '../../../vuex/common';
import CustomerGroupSettings from '../../search/CustomerGroupSettings.vue';

export default Vue.extend({
  mixins: [customerVuex],
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showGroupSettings: false,
    };
  },
  components: {
    CustomerGroupSettings,
  },
  computed: {
    displayGroups(): string {
      let text = '';
      if (this.customerState.customerGroups.length > 0) {
        text = this.customer.groups.map((g: any) => {
          const group = this.customerState.customerGroups.find((gp: any) => gp.id === g);
          return group ? group.name : '';
        }).join(',');
      }
      return text ? text : '-';
    },
  },
});
